<div class="atlas-form flx-layout-column flx-gap-20px mb-27">
  <div class="atlas-autocomplete flx-layout-column">
    <label class="light-text">{{ 'revenue.gateway-resolution-tree.selector-item-label' | translate | titlecase }}</label>
    <p-autocomplete
      class="gateway-resolution-selector-item"
      appendTo="body"
      optionLabel="label"
      [(ngModel)]="selected.item"
      [suggestions]="suggestions.item"
      (completeMethod)="search('item', $event)"
      (onSelect)="select('item', $event)"
      (onClear)="clear('item')"
      [dropdown]="true"
      [forceSelection]="true"
      [showClear]="true"
      [disabled]="loadFailed.item"
      [showEmptyMessage]="true"
      [emptyMessage]="'revenue.gateway-resolution-tree.selector-no-results' | translate"
      [placeholder]="'revenue.gateway-resolution-tree.selector-item-placeholder' | translate | titlecase"
    ></p-autocomplete>
  </div>
  <div class="atlas-autocomplete flx-layout-column">
    <label class="light-text">{{ 'revenue.gateway-resolution-tree.selector-accounting-package-label' | translate | titlecase }}</label>
    <p-autocomplete
      class="gateway-resolution-selector-accounting-package"
      appendTo="body"
      optionLabel="label"
      [(ngModel)]="selected.accountingPackage"
      [suggestions]="suggestions.accountingPackage"
      (completeMethod)="search('accountingPackage', $event)"
      (onSelect)="select('accountingPackage', $event)"
      (onClear)="clear('accountingPackage')"
      [dropdown]="true"
      [forceSelection]="true"
      [showClear]="true"
      [disabled]="loadFailed.accountingPackage"
      [showEmptyMessage]="true"
      [emptyMessage]="'revenue.gateway-resolution-tree.selector-no-results' | translate"
      [placeholder]="'revenue.gateway-resolution-tree.selector-accounting-package-placeholder' | translate | titlecase"
    ></p-autocomplete>
  </div>
  <div class="atlas-autocomplete flx-layout-column">
    <label class="light-text">{{ 'revenue.gateway-resolution-tree.selector-payment-type-label' | translate | titlecase }}</label>
    <p-autocomplete
      class="gateway-resolution-selector-payment-type"
      appendTo="body"
      optionLabel="label"
      [(ngModel)]="selected.paymentType"
      [suggestions]="suggestions.paymentType"
      (completeMethod)="search('paymentType', $event)"
      (onSelect)="select('paymentType', $event)"
      (onClear)="clear('paymentType')"
      [dropdown]="true"
      [forceSelection]="true"
      [showClear]="true"
      [disabled]="loadFailed.paymentType"
      [showEmptyMessage]="true"
      [emptyMessage]="'revenue.gateway-resolution-tree.selector-no-results' | translate"
      [placeholder]="'revenue.gateway-resolution-tree.selector-payment-type-placeholder' | translate | titlecase"
    ></p-autocomplete>
  </div>
  <div class="atlas-autocomplete flx-layout-column">
    <label class="light-text">{{ 'revenue.gateway-resolution-tree.selector-gateway-label' | translate | titlecase }}</label>
    <p-autocomplete
      class="gateway-resolution-selector-gateway"
      appendTo="body"
      optionLabel="label"
      [(ngModel)]="selected.gateway"
      [suggestions]="suggestions.gateway"
      (completeMethod)="search('gateway', $event)"
      (onSelect)="select('gateway', $event)"
      (onClear)="clear('gateway')"
      [dropdown]="true"
      [forceSelection]="true"
      [showClear]="true"
      [disabled]="loadFailed.gateway"
      [showEmptyMessage]="true"
      [emptyMessage]="'revenue.gateway-resolution-tree.selector-no-results' | translate"
      [placeholder]="'revenue.gateway-resolution-tree.selector-gateway-placeholder' | translate | titlecase"
    ></p-autocomplete>
  </div>
  <div class="flx-layout-column">
    <label class="light-text">{{ 'revenue.gateway-resolution-tree.selector-invoice-label' | translate | titlecase }}</label>
    <div class="flx-layout-row flx-align-start-center flx-gap-8px">
      <input
        pInputText
        type="text"
        class="gateway-resolution-selector-invoice"
        inputmode="numeric"
        [(ngModel)]="invoiceText"
        (keydown.enter)="applyInvoice()"
        (blur)="applyInvoice()"
        [placeholder]="'revenue.gateway-resolution-tree.selector-invoice-placeholder' | translate"
      />
      <button
        *ngIf="invoiceText"
        pButton
        type="button"
        class="pi pi-times"
        (click)="clearInvoice()"
      ></button>
    </div>
    <small *ngIf="invoiceInvalid" class="gateway-resolution-selector-invoice-invalid">{{ 'revenue.gateway-resolution-tree.selector-invoice-invalid' | translate }}</small>
  </div>
</div>
